import { useState } from 'react';
import { SettingsCache } from '~/lib/consts/settings-cache';
import AlertWithIcon from '../AlertWithIcon';
import { SvgEnquiryExclamation, P2GText, P2GLink, P2GBox } from '@parcel2go/core-ui';
import { useTaxName } from '@parcel2go/npm-p2g-app';

interface props {
  recipientIsoCode: string;
}

export const AdditionalCustomsNotice: React.FC<props> = (props) => {
  const [show, setShow] = useState(false);
  const taxName = useTaxName();

  if (!SettingsCache.settings.Features.includes('AdditionalDutiesWarning')) {
    return null;
  }

  switch (props.recipientIsoCode) {
    case 'FRA':
      return (
        <AlertWithIcon color="error" icon={<SvgEnquiryExclamation />}>
          <P2GText variant="body2" component="p">
            <strong>Please Note:</strong> Additional tax and duties may be required by French Customs Authorities.{' '}
            <P2GLink onClick={() => setShow(!show)}>Why?</P2GLink>
          </P2GText>
          {show && (
            <P2GBox mt={1}>
              <P2GText variant="body2" component="p">
                Items sold via your sales channel are subject to additional checks by French customs authorities, who
                may charge {taxName} on items deemed exempt from{' '}
                <P2GLink href="https://www.parcel2go.com/international-shipping-hub/business/ioss" target="_blank">
                  IOSS
                </P2GLink>
                . We have no control over these charges, which should be paid or disputed directly with the customs
                authority.
              </P2GText>
            </P2GBox>
          )}
        </AlertWithIcon>
      );

    default:
      return null;
  }
};
